import { useBooleanState } from '@cian/react-utils';
import { Button, CustomTooltip, IconChevronLeft16, IconChevronRight16, TooltipDesktop } from '@cian/ui-kit';

import { FC, useRef } from 'react';

import { useToggleMapButtonHintContext } from '../../context/ToggleMapButtonHintContext';

import styles from './ToggleMapButton.css';

type ToggleMapButtonProps = {
  isMapOpen: boolean;
  toggleMapOpen: VoidFunction;
};

export const ToggleMapButton: FC<ToggleMapButtonProps> = props => {
  const { isMapOpen, toggleMapOpen } = props;
  /**
   * Почему контролируемый тултип:
   * - при клике на кнопку, если event.target - svg, то тултип не пропадает
   * - видимо дело в том, что не происходит "onMouseOut"
   * - поэтому при клике насильно руками закрываем тултип
   */
  const { state: isTooltipOpen, setTrue: setTooltipOpen, setFalse: setTooltipClosed } = useBooleanState(false);

  const hintRef = useRef<HTMLSpanElement>(null);

  /**
   * На маунте показываем тултип-подсказку, которая "приклеена" к кнопке открытия карты. Этот тултип закрывается
   * по нажатию на "крестик" или через открытие карты. Когда тултип-подсказка убрана, показываем обычный
   * тултип "Свернуть/Показать" по ховеру на кнопку
   */
  const { isMapHintOpen, handleMapHintClose } = useToggleMapButtonHintContext();

  const icon = isMapOpen ? <IconChevronRight16 color="primary_100" /> : <IconChevronLeft16 color="primary_100" />;
  const tooltipTitle = isMapOpen ? 'Свернуть карту' : 'Показать карту';

  return (
    <>
      <TooltipDesktop open={isTooltipOpen} placement="left" title={tooltipTitle}>
        <span className={styles['button-wrapper']} ref={hintRef}>
          <Button
            beforeIcon={icon}
            data-testid="map-controls.toggle-map"
            size="XS"
            theme="fill_white_primary"
            onClick={(): void => {
              toggleMapOpen();
              setTooltipClosed();
              handleMapHintClose();
            }}
            onMouseOut={setTooltipClosed}
            onMouseOver={(): void => {
              if (!isMapHintOpen) {
                setTooltipOpen();
              }
            }}
          />
        </span>
      </TooltipDesktop>
      <CustomTooltip
        anchorRef={hintRef}
        arrow={true}
        closeButton={true}
        content={<div className={styles['hint-content']}>Разверните её, чтобы посмотреть расположение объектов</div>}
        flip={false}
        header="Карта переехала вправо"
        open={isMapHintOpen}
        placement="left-start"
        portal={false}
        theme="black"
        onClose={handleMapHintClose}
      />
    </>
  );
};
